import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx)
//authentification HelloId
import AuthService from "./services/AuthService";

import axios from "axios";
import VueAxios from "vue-axios";

Vue.config.productionTip = false


//singleton proprertie for Vue Application
let mgr = new AuthService();
Vue.prototype.$authService = mgr;

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.VUE_APP_BASE_ROOT;

function logOut() {
  window.localStorage.clear();
  store.commit("resetUser");
  store.commit("resetState");
}

router.beforeEach((to, from, next) => {

  // console.log("Router - Store : ", store.state)
  // console.log("BEFORE EACH ROUTER !")

  // route qui demande l'authentification
  if (to.meta.requiresAuth) {
    if (store.state.user) {
      const token = store.state.user.access_token;
      if (token) {
        // console.log("ON TEST LE TOKEN");
        // controle que le token n'est pas expiré
        try {
          const payload = JSON.parse(Buffer.from((token.split(".")[1]), 'base64'));
          // console.log(`payload`, payload);
          const exp = payload.exp;
          const date = Date.now().toString();
          const subDate = date.substring(0, 10);
          if (Number(subDate) > exp) {
            logOut();
            // console.log("ON LOG OUT")
          }
          next()
        } catch (err) {
          console.log(`err`, err);
          logOut();
          // console.log("ON LOG OUT")
          next();
        }
      } else {
        //save current route
        let url = to.path;
        store.commit("setCurrentUrl", url);
        // console.log("Saved route > " + url);
        // console.log("REDIRECT VERS LOGIN CAR PAS DE TOKEN");
        next({
          name: "login"
        })
      }
    } else {
      //save current route
      let url = to.path;
      store.commit("setCurrentUrl", url);
      // console.log("REDIRECT TO LOGIN");
      // console.log("Saved route > " + url);
      next({
        name: "login"
      })
    }
  } else {
    next()
  }
})


new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')





